import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import classnames from 'classnames';

import Instagram from './instagram.js';
import Facebook from './facebook.js';
import NSF from './nsf.js';

import { WeftMark }  from './WeftMark';

import * as newsletterActions from '../../actions/newsletterActions';


class EmailForm extends Component {
  getButtonText() {
    const { status } = this.props.newsletter;
    switch (status) {
      case 'SUCCEEDED':
        return <i className={'material-icons'}>check</i>;
      case 'FAILED':
        return <i className={'material-icons'}>close</i>;
      default:
        return <i className={'material-icons'}>arrow_forward</i>;
    }
  }

  render() {
    return(
      <div className={'email-form'}>
        <form className={'emailForm'} onSubmit={this.props.handleSubmit}>
          <Field
            className={'email-input__email'}
            type={'email'}
            placeholder={'Sign up for updates'}
            name={'email'}
            component={'input'}
          />

          <button
            type={'submit'}
            className={classnames({
              done: this.props.newsletter.status === 'SUCCEEDED',
              invalid: this.props.newsletter.status === 'FAILED',
            })}
            disabled={this.props.newsletter.status === 'PENDING'}
          >
             {this.getButtonText()}
          </button>
        </form>
      </div>
    );
  }
}

EmailForm = reduxForm({
  form: 'emailForm',
})(EmailForm);


class FooterShop extends Component {
	subscribeToNewsletter = event => {
		// const email = document.getElementById('email-input').value;
	};

	render() {
		return(
			<footer className={'footer'}>
				<div className={'container'}>


					<div className={'columns'}>
						<div className={'column'}>
							<div className={'footer-logo'}>
								<WeftMark />
							</div>
						</div>

						<div className={'column columns is-mobile is-half'}>
							<div className={'footer-column column'}>
								{/* <div className={'shop-footer__link'}>
									<a href={'/about'} className={'shop-footer__link-item'}>{'About'}</a>
								</div> */}

								<div className={'shop-footer__link'}>
									<a href={'/how'} className={'shop-footer__link-item'}>{'How it Works'}</a>
								</div>

								<div className={'shop-footer__link'}>
									<a href={'/qualities'} className={'shop-footer__link-item'}>{'Fabric Qualities'}</a>
								</div>

								<div className={'shop-footer__link'}>
									<a href={'/tutorials'} className={'shop-footer__link-item'}>{'Tutorials'}</a>
								</div>

                <div className={'shop-footer__link'}>
									<a href={'/faq'} className={'shop-footer__link-item'}>{'FAQs'}</a>
								</div>
							</div>

							<div className={'footer-column column'}>
								<div className={'shop-footer__link'}>
									<a href={'/b2b'} className={'shop-footer__link-item'}>{'Weft B2B'}</a>
								</div>

								<div className={'shop-footer__link'}>
									<a href={'/shipping'} className={'shop-footer__link-item'}>{'Shipping & Returns'}</a>
								</div>

								<div className={'shop-footer__link'}>
									<a href={'/terms'} className={'shop-footer__link-item'}>{'Terms of Service'}</a>
								</div>

								<div className={'shop-footer__link'}>
									<a href={'/privacy'} className={'shop-footer__link-item'}>{'Privacy Policy'}</a>
								</div>
							</div>
						</div>

						<div className={'footer-column column'}>
							<div className={'footer-shop__newsletter'}>
								<EmailForm
									newsletter={this.props.newsletter}
									onSubmit={this.props.subscribe}
        />
							</div>

							<div className={'footer-shop__social'}>
								<a href={'https://www.instagram.com/weft.design/'} target={'_blank'} rel={'noopener'} className={'footer-shop__social-link instagram'}>
									<Instagram />
								</a>

								<a href={'https://www.facebook.com/weft.design/'} target={'_blank'} rel={'noopener'} className={'footer-shop__social-link facebook'}>
									<Facebook />
								</a>

								<a href={'https://www.nsf.gov/eng/iip/sbir/home.jsp'} target={'_blank'} rel={'noopener'} className={'footer-shop__social-link nsf'}>
									<NSF />
								</a>
							</div>

							<div className={'footer-shop__copyright'}>
								<a href={'http://www.computationaltextiles.io'} target={'_blank'} rel={'noopener'}>{'©2016-2024 Computational Textiles, Inc'}</a>
                <a href={'mailto:hello@weft.design'} target={'_blank'} rel={'noopener'} className={'link'}>{'hello@weft.design'}</a>
            	</div>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

function mapStateToProps(state) {
  return {
    newsletter: state.newsletter,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...newsletterActions}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterShop);
